enum LocaleCode {
  ENGLISH = 'en',
  KOREAN = 'ko',
  CHINESE = 'zh-CN',
  JAPANESE = 'ja',
  VIETNAMESE = 'vi',
}

export default LocaleCode;
